const TechnicalType = `
  id
  description
  updatedAt
`;

export default TechnicalType;
